import { FormField } from './field';
import { FieldControl } from '@signature-it/ngx-generic/enums';
import {formatDate} from "@angular/common";

export class DateField extends FormField {
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.controlType = options['controlType'] || FieldControl.DATE_INPUTS;
    }

    getTitle(value) {
        return value && !isNaN(value) ?  formatDate(new Date(value * 1000), 'dd/MM/yyyy', 'en_US') : '';
    }
}
